import React from 'react';
import { IValidator } from '../../hooks/useValidator';
import { Variant } from '../../common/variant';
import { Text, ITextBaseProps } from '../../Typography/Text/Text';
import { Size } from '../../common/size';
import { useTestId } from '../../hooks/useTestId';

export interface IValidationErrorMessageProps extends Pick<ITextBaseProps, 'size'> {
  validator: IValidator<any>;
}

export const ValidationErrorMessage: React.FC<IValidationErrorMessageProps> = ({ validator, size = Size.Small, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'ValidationErrorMessage');
  return (
    <>
      {validator.results
        .filter((x) => !x.valid)
        .map((x) => (
          <Text size={size} key={x.id ?? x.message} variant={Variant.Error} {...generateTestId(`Text${x.id ?? x.message}`)}>
            {x.message}
          </Text>
        ))}
    </>
  );
};
